import React, { useState } from 'react'
import { Drawer, Dropdown, Menu, Tabs } from 'antd'
import { Route, Switch, useHistory, Link, useParams } from 'react-router-dom'

import { AiOutlineDown } from 'react-icons/ai'

import { useToggle, stringifyDate, usePet, normalize } from '../../modules'

const { TabPane } = Tabs

const Message = ({ path, onClose }) => {
    const [chosen, setChosen] = useState([])
    const [selected, setSelected] = useState(null)
    const [index, setIndex] = useState(null)
    const [can, setCan] = useState(null)
    const [params, setParams] = useState({})
    
    const history = useHistory()
    const { id } = useParams()

    const [visible, toggleVisible] = useToggle(true)
    const [select, toggleSelect] = useToggle()
    const [editModal, toggleEditModal] = useToggle()

    // const [{ loading, error, data: invoice }, refetch] = usePet('invoice', { id }, { notify: true })

    // const [{ loading: editLoading }, editInvoiceItem] = usePet('editInvoiceItem', {
    //     parent: id,
    //     index,
    //     ...params
    // }, { notify: true, callback: refetch, manual: true, load: { msg: 'Saving changes...' } })

    // const [{ loading: newLoading }, addItemToInvoice] = usePet('addItemToInvoice', {
    //     parent: id,
    //     ...params
    // }, { notify: true, callback: refetch, manual: true, load: { msg: 'Saving changes...' } })

    // const [{ loading: comLoading }, commitInvoice] = usePet('commitInvoice', { id }, { notify: true, callback: () => {
    //     refetch()
    //     onClose()
    // }, manual: true, load: { msg: 'Saving changes...' } })
    
    const togSelect = () => {
        setChosen([])
        toggleSelect()
    }

    const selectItems = (val, i) => {
        setSelected(val)
        setIndex(i)
        toggleEditModal()
    }

    const choose = id => {
        let temp = [...chosen]

        if (temp.includes(id)) {
            temp = temp.filter(x => x !== id)
        } else {
            temp.push(id)
        }

        setChosen(temp)
    }

    const close = () => {
        toggleVisible()
        // onClose()
        setTimeout(() => history.goBack(), 300)
    }

    // const [{ loading: delLoading }, deleteInvoice] = usePet('deleteInvoice', { id }, { notify: true, callback: () => {
    //     onClose()
    //     setTimeout(close, 200)
    // }, manual: true, load: { msg: 'Saving changes...' } })

    const getCount = item => item?.singles ? item.bulkCount : item.bulkCount * item.containing

    const messages = [
        {
            id: 1,
            recipient: 'John Doe',
            createdBy: 'Dummy',
            status: false,
            contacts: [
                {name: 'John Doe', contact: '0712345678'},
                {name: 'John Doe', contact: '0712345678'},
                {name: 'John Doe', contact: '0712345678'},
                {name: 'John Doe', contact: '0712345678'},
                {name: 'John Doe', contact: '0712345678'},
                {name: 'John Doe', contact: '0712345678'}
            ],
            message: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam euismod, nisl eget aliquam ultricies, nunc nisl aliquet nunc, quis aliquam nisl nunc sit amet nisl.' 
        },
        {
            id: 2,
            recipient: 'John Doe',
            createdBy: 'Dummy',
            status: true,
            contacts: [
                {name: 'John Doe', contact: '0712345678'},
                {name: 'John Doe', contact: '0712345678'},
                {name: 'John Doe', contact: '0712345678'},
                {name: 'John Doe', contact: '0712345678'},
                {name: 'John Doe', contact: '0712345678'},
                {name: 'John Doe', contact: '0712345678'}
            ],
            message: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam euismod, nisl eget aliquam ultricies, nunc nisl aliquet nunc, quis aliquam nisl nunc sit amet nisl.'
        },
        {
            id: 3,
            recipient: 'John Doe',
            createdBy: 'Dummy',
            status: true,
            contacts: [
                {name: 'John Doe', contact: '0712345678'},
                {name: 'John Doe', contact: '0712345678'},
                {name: 'John Doe', contact: '0712345678'},
                {name: 'John Doe', contact: '0712345678'},
                {name: 'John Doe', contact: '0712345678'},
                {name: 'John Doe', contact: '0712345678'}
            ],
            message: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam euismod, nisl eget aliquam ultricies, nunc nisl aliquet nunc, quis aliquam nisl nunc sit amet nisl.'
        },
        {
            id: 4,
            recipient: 'John Doe',
            createdBy: 'Dummy',
            status: true,
            contacts: [
                {name: 'John Doe', contact: '0712345678'},
                {name: 'John Doe', contact: '0712345678'},
                {name: 'John Doe', contact: '0712345678'},
                {name: 'John Doe', contact: '0712345678'},
                {name: 'John Doe', contact: '0712345678'},
                {name: 'John Doe', contact: '0712345678'}
            ],
            message: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam euismod, nisl eget aliquam ultricies, nunc nisl aliquet nunc, quis aliquam nisl nunc sit amet nisl.'
        },
        {
            id: 5,
            recipient: 'John Doe',
            createdBy: 'Dummy',
            status: true,
            contacts: [
                {name: 'John Doe', contact: '0712345678'},
                {name: 'John Doe', contact: '0712345678'},
                {name: 'John Doe', contact: '0712345678'},
                {name: 'John Doe', contact: '0712345678'},
                {name: 'John Doe', contact: '0712345678'},
                {name: 'John Doe', contact: '0712345678'}
            ],
            message: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam euismod, nisl eget aliquam ultricies, nunc nisl aliquet nunc, quis aliquam nisl nunc sit amet nisl.'
        },
        {
            id: 6,
            recipient: 'John Doe',
            createdBy: 'Dummy',
            status: true,
            contacts: [
                {name: 'John Doe', contact: '0712345678'},
                {name: 'John Doe', contact: '0712345678'},
                {name: 'John Doe', contact: '0712345678'},
                {name: 'John Doe', contact: '0712345678'},
                {name: 'John Doe', contact: '0712345678'},
                {name: 'John Doe', contact: '0712345678'}
            ],
            message: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam euismod, nisl eget aliquam ultricies, nunc nisl aliquet nunc, quis aliquam nisl nunc sit amet nisl.'
        },
        {
            id: 7,
            recipient: 'John Doe',
            createdBy: 'Dummy',
            status: true,
            contacts: [
                {name: 'John Doe', contact: '0712345678'},
                {name: 'John Doe', contact: '0712345678'},
                {name: 'John Doe', contact: '0712345678'},
                {name: 'John Doe', contact: '0712345678'},
                {name: 'John Doe', contact: '0712345678'},
                {name: 'John Doe', contact: '0712345678'}
            ],
            message: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam euismod, nisl eget aliquam ultricies, nunc nisl aliquet nunc, quis aliquam nisl nunc sit amet nisl.'
        }
    ]

    const contacts = [
        { name: 'John Doe', contact: '0712345678', groups: ['Group 1', 'Group 2'] },
        { name: 'Jane Doe', contact: '0712345678', groups: ['Group 1', 'Group 2'] },
        { name: 'John Doe', contact: '0712345678', groups: ['Group 1', 'Group 2'] },
        { name: 'Jane Doe', contact: '0712345678', groups: ['Group 1', 'Group 2'] },
        { name: 'John Doe', contact: '0712345678', groups: ['Group 1', 'Group 2'] },
        { name: 'Jane Doe', contact: '0712345678', groups: ['Group 1', 'Group 2'] },
        { name: 'John Doe', contact: '0712345678', groups: ['Group 1', 'Group 2'] },
        { name: 'Jane Doe', contact: '0712345678', groups: ['Group 1', 'Group 2'] },
        { name: 'John Doe', contact: '0712345678', groups: ['Group 1', 'Group 2'] },
        { name: 'Jane Doe', contact: '0712345678', groups: ['Group 1', 'Group 2'] }
    ]

    return (
        <Drawer
            closable
            maskClosable
            visible={visible}
            onClose={close}
            width="40%">
            {/* <p className="font-extrabold text-3xl mb-0">Message #{messages?.id}</p> */}
            <p className="font-extrabold text-3xl mb-0">Message # {id}</p>
            <Tabs className="mt-0">
                <TabPane key="0" tab="Message Details">
                        <div className="flex flex-col pr-3 py-3">
                            <p className="font-semibold text-lg mb-2">Created By:</p>
                            <p>{messages[id].createdBy}</p>
                            <p className="font-semibold text-lg mb-2">Groups:</p>
                            <p>yet to modify schema</p>
                            <p className="font-semibold text-lg mb-2">Message Body:</p>
                            <p>{messages[id].message}</p>
                        </div>
                </TabPane>
                <TabPane key="1" tab="Contact Details">
                <table className="table-auto w-full">
                            {/* Table header */}
                            <thead className="text-xs uppercase text-gray-400 bg-gray-50 rounded-sm">
                                <tr>
                                    <th className="p-2">
                                        <div className="font-semibold text-left">No</div>
                                    </th>
                                    <th className="p-2">
                                        <div className="font-semibold text-left">Name</div>
                                    </th>
                                    <th className="p-2">
                                        <div className="font-semibold text-left">Contact</div>
                                    </th>
                                    <th className="p-2">
                                        <div className="font-semibold text-left">Groups</div>
                                    </th>
                                </tr>
                            </thead>
                            <tbody className="text-sm font-medium divide-y divide-gray-100">
                                {
                                    messages[id]?.contacts.map((item, key) =>
                                        <tr>
                                            <td className="p-2">
                                                <div className="text-left">{key + 1}</div>
                                            </td>
                                            <td className="p-2">
                                                <div className="text-left">{item?.name}</div>
                                            </td>
                                            <td className="p-2">
                                                <div className="text-left">{item?.contact}</div>
                                            </td>
                                            <td>
                                                <div className="text-left">Not set yet</div>
                                            </td>
                                        </tr>
                                    )
                                }
                            </tbody>
                        </table>
                </TabPane>
            </Tabs>
            <Switch>
                <Route path={ `${path}/contact/:id`}>
                    <Drawer
                        closable
                        maskClosable
                        onClose
                        width="60%">
                        <p>Test</p>
                    </Drawer>
                </Route>
            </Switch>
        </Drawer>
    )
}

export default Message